// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  selectedUser: null
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.total,
        params: action.params
      }
    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
      const data = [...state.data]

      //Adding new user
      data.push(action.data)
      return { ...state, data }
    case 'DELETE_USER':
      return { ...state }
    default:
      return { ...state }
  }
}
export default users
